// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@400;500;600;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  font-family: 'Jost';
  background-color: #f7f7fd;
  color: #112c4c;
}


.btn-secondary {
  color: #fff;
  background-color: #112c4c;
  border-color: #112c4c;
}

.borde-img {
  border-radius: 10px;
  border-style: solid;
  border-color: #ffffff;
  border-width: 1px;
  overflow: hidden;
}

.descripcionap{
  border-radius: 5px;
  background-color: #ffffff;
  padding: 20px;
  margin-top: 20px;
}

a {
    color: #02aaec;
    text-decoration: none;
}

.nav-link:focus, .nav-link:hover {
  color: #0b6d9b;
}

a:hover {
  color: #0b6d9b;
}

.card-e a{
  color: #112c4c !important;
}

.btn-primary {
  color: #fff !important;
  background-color: #02aaec;
  border-color: #02aaec;
}
.btn-danger{
  background-color: #d37c35;
  border-color: #d37c35;
}


.login .btn{
  width: 100%;
  padding: 13px 20px;
  font-size: 1.2rem;
}
.login .logo{
  padding: 50px;
  width: 220px;
}
.login .iniciodes{
  display: inline-block;
}
.login .iniciodes hr{
  background-color: #00b1e6;
  margin-top: -5px;
  height: 2px;
  opacity: 1;
}


.login .form-control {

    border-radius: 6px;
    border: 1px solid #d5e0ee;
    background-color: #f9fbfe;
    align-self: start;
    display: flex;
    margin-top: 7px;
    width: 100%;
    height: 50px;
    flex-direction: column;

}

.login label {
  margin-top: 15px;
}

.login .olvidaste{
  float: right;
  margin-right: 10px;
}



.bg-dark {
  color: #fff!important;
  background-color: #112c4c!important;
  padding: 19px 48px 19px 50px;
}

.nav-link {
  color: #fff;
  margin: 0 10px 0 10px;
}

.link-secondary {
  color: #a5a5a5!important;
}

.img-nav{
  vertical-align:top;
  margin-right: 2px;
}

.logo-w{
  width: 142px;
  padding-left: 100px;
}


.enc{
    font-size: 1.1rem;
    margin: 0px 0 10px 0;

}

.card1{

    border-radius: 8px;
    border: 1px solid #ededfb;
    background-color: #fff;
    width: 100%;
    margin: 0 auto;


}

.img1{
  width: 200px;
}

.card-title{
  color: #02aaec;
  font-size: 1.3rem;
}

.circle{
  height: 15px;
  vertical-align: baseline;
}

.astats{
  height: 45px;
}

.ainfo{
  text-align: left;
}


h4{
  font-weight: 600;
}

.table1 h4{
  text-align: center;
  margin-bottom: 15px;
}

th {
  font-weight: 600;
}



.colmd3{
  background-color: #ffffff;
  border-radius: 5px;
}

.rendimiento{
  padding: 15px 0px;
  position: relative;
  border: 1px solid #ffffff;
  display: flex;
  flex-direction: column;
}

.rendimiento h4{
  text-align: center;
}

.rendimiento select{
  margin: 12px auto;
  display: block !important;
  width: 200px;
  text-align: center;
}


.crendimiento{
  width: 100%;
}

.rultimos{
  width: 100%;
  height: 350px;
}


.prendimiento{
  width: 100%;
  color: #ffffff;
  background-color: #112c4c;
  border-radius: 5px;
  font-size: 5rem;
  font-weight: 600;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 20px 30px;
  width: 80%;
}

.inversioninfo hr{
  color: #dfdfdf;
  margin: 0 !important;
}

.inversioninfo{
  margin-top: 15px;
}
.inversioninfo h2{
  font-weight: bold;
  text-align: center;
}

.inversioninfo span{
  text-align: center;
  display: block;
  color: #999999;
  font-size: 1.1rem;
}



.perfil{
  text-align: center;
  padding: 15px 15px;
}

.perfil img{
  margin: 5px;
  margin-bottom: 15px;
}

.pinfo{
  background-color: #f7f7fd;
  border-radius: 5px;
  border: 1px solid rgba(223, 223, 223, 0.521);
}

.separa{
  border-left: 1px solid #dfdfdf;
}

.pinfo .row .col {
  padding: 10px;
}
.pinfo .row .col span{
  font-size: 0.7rem;
}

.pinfo .row .col h6{
  margin-bottom: 2px;
}


.charts{
  background-color: #fff;
  padding: 20px 10px 120px 10px;
  border-radius: 8px;
  height: 500px;
  
}


.charts-1{
  background-color: #fff;
  padding: 20px 10px 50px 10px;
  border-radius: 8px;
  height: 500px;
  
}
.charts-rentals{
  background-color: #fff;
  padding: 20px 10px 50px 10px;
  border-radius: 8px;
  height: 400px;
  
}

.charts-sales{
  background-color: #fff;
  padding: 20px 10px 50px 10px;
  border-radius: 8px;
  height: 407px;
  
}

.tit-flujo{
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 20px;
}

.usd-flujo{
  font-size: 2rem;
  font-weight: 800;
  margin-left: 20px;
}

.porc-flujo{
  font-size: 1.2rem;
  color: #00ad45;
  font-weight: 600;
  margin-left: 10px;
}


.flujo{
  width: 150px;
  float: right;
}

.wflujo{
  width: 100%;
  height: 100%;
}

.table1 h5{
  text-align: center;
}
.table{
  color: #112c4c !important;
}
.table1{
  background-color: #fff;
  padding: 20px 30px 10px 30px;
  border-radius: 8px;
  font-size: 0.9rem;
}

.table>:not(:first-child) {
  border-top: 0px solid transparent !important;
}

.table>thead {
  vertical-align: bottom;
  background-color: #f2f2fd !important;
  border-radius: 5px;
}

.cverde{
  color: #00ff00;
  vertical-align: bottom;
}

.min49 {
  min-width: 49px;
}









.cwhite{
  background-color: #ffffff;
  border-radius: 5px;
}
.cdark{
  background-color: #112c4c;
  border-radius: 5px;
  color: #ffffff;
  padding: 38px 50px;
}

.cdark > span{
  font-size: 1.2rem;
  margin-left: 17px;
}

.cdark div{
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
}

.cdark div span{
  border-bottom: 2px solid #f25948;

}





.cdark2{
  background-color: #112c4c;
  border-radius: 5px;
  color: #ffffff;
  padding: 38px 50px;
}

.cdark2 > span{
  font-size: 1.2rem;
  margin-left: 17px;
}

.cdark2 div{
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
}

.cdark2 div span{
  border-bottom: 2px solid #f25948;

}




.cdark3{
  background-color: #6b8bb1;
  border-radius: 5px;
  color: #ffffff;
  padding: 38px 50px;
}

.cdark3 > span{
  font-size: 1.2rem;
  margin-left: 17px;
}

.cdark3 div{
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
}

.cdark3 div span{
  border-bottom: 2px solid #ffffff;

}




.corange{
  background-color: #ff9f5e;
  border-radius: 5px;
  color: #ffffff;
  padding: 38px 50px;
}

.corange > span{
  font-size: 1.2rem;
  margin-left: 17px;
}

.corange div{
    width: 100%;
    text-align: center;
    font-size: 1.7rem;
    font-weight: bold;
}

.corange div span{
  border-bottom: 2px solid #ffffff;

}



.cwhiteinfo{
  background-color: #ffffff;
  border-radius: 5px;
  padding: 38px 50px;
}

.cwhiteinfo > span{
  font-size: 1.2rem;
  margin-left: 17px;
  color: #999999;
}

.cwhiteinfo div{
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
}

.cwhiteinfo div span{
  border-bottom: 2px solid #ff9955;

}



.arotop{
  text-align: center;
}
.aro{
  width: 150px;
  display: inline-block;
}

.ocup{
  width: 150px;
  display: inline-block;
  text-align: center;
  color: #999999;
  font-size: 1.3rem;
  vertical-align:middle;
}


.periodo{
  width: 150px;
  display: inline-block;
}
.title-gr{
  margin-right: 20px;
  font-size: 1.25rem;
  font-weight: 500;
}


@media (max-width: 1500px) {
  .logo-w {
    width: 40px;
    padding-left: 0px;
}
}



























@media (max-width: 768px) { 
  .charts{
    margin-top: 30px;
  }
  .nav-link {
    padding: 1rem 1rem;
    font-size: 1.5rem;
  }
  .nav-item{
    border-top: 1px solid rgba(255, 255, 255, 0.219);
  }
  .navbar-collapse{
    margin-top: 30px;
  }
  .img-nav{
    vertical-align:middle;
  }
}






.table1 div h4{
  color:#ff9955;
  text-align: center;
}

.table1 div h4 i{
  color:#02AAEC;
  margin: 0 30px;
  cursor: pointer;
}

tbody tr th i{
  color: #00D293;
  margin-right: 10px;
}

.gris{
  color: #c0c0c0;
}








.mkplace{
  padding: 10px 5px 10px 0px ;
  text-align: center;
}

.mkplace h5 a{
  color:#112c4c;
}

.timeline {
  position: relative;
  margin: 20px 0;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 30px;
  width: 2px;
  border: 1px dashed #e0e0f6;
  margin-left: -1px; /* Para corregir el espacio en blanco a la izquierda de la línea */
  z-index: 0;
}

.timeline-item {
  position: relative;
  padding: 0px 20px;
  margin-bottom: 40px;
  margin-left: 50px; /* Ajusta la separación entre la línea y el contenido */
  z-index: 1;
}

.timeline-item > .row{
  margin-bottom: 10px;
}

.timeline-item .row .col{
  margin-top: -20px;
}

.timeline-item .row .col a{
  font-weight: 600;
  color: #112c4c;
}

.timeline-item .row .col a:hover{
  font-weight: 600;
  color: #0c58b6;
}

.timeline-item::before {
content: '\\f1d8';
font-family: 'Font Awesome 5 Free';
font-weight: 900;
color: #ffffff;
position: absolute;
text-align: center;
padding-top: 7px;
left: -39px;
width: 40px;
height: 40px;
border-radius: 50%;
background-color: #112c4c;
transform: translateY(-50%);
z-index: 1;
}

.fechamp{
  font-size: 0.7rem;
  color: #666666;
}

.disponiblemp{
  color: #00ad45;
  background-color: #deffeb;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 3px 6px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-radius: 5px;
}

.mkplace h5{
  text-align: center;
  font-weight: 600;
  padding: 10px;
}

.contmp{
  border:1px solid #e6e6e6;
  border-radius: 5px;
  padding: 10px 10px 5px 10px;
}

.contmp hr{
  margin: 3px;
}

.contmp .row .col-8{
  text-align: right;
}

.tituloitemmp{
  color:#02aaec;
  font-weight: 600;
}
.demp{
  font-size: 0.8rem;
  font-style: italic;
}

.tirvan{
  font-size: 0.9rem;
  color: #666666;
}
.parti{
  font-weight: 600;
  text-align: center;
}

.mkplace .btn-secondary{
  font-weight: 600;
  text-align: center;
}























.l-proyectos a{
  color: #112c4c;
}

.divcard {
  border-radius: 8px;
  background-color: #fff;
  color: #112c4c;
  display: flex;
  width: 374px;
  flex-direction: column;
  margin: 20px auto;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
.cardinfo{
  padding: 20px;
  }

.img {
  /*aspect-ratio: 1.73;*/
  object-fit: contain;
  object-position: center;
  width: 100%;
  overflow: hidden;
  align-self: stretch;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.div-2 {
  align-self: stretch;
  display: flex;
  margin-top: 0px;
  flex-direction: column;
  width: 100%;
  /*padding: 0 24px 0 25px;*/
}
@media (max-width: 991px) {
  .div-2 {
    /*padding: 0 20px;*/
  }
}
.div-3 {
  
  text-transform: capitalize;
  align-self: stretch;
  white-space: nowrap;
  font: 600 18px Jost, sans-serif;
}
@media (max-width: 991px) {
  .div-3 {
    white-space: initial;
  }
  
}
.div-4 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  gap: 6px;
}
.img-2 {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 16px;
  overflow: hidden;
  align-self: center;
  max-width: 100%;
  margin: auto 0;
}

.div-5 {
  color: #444;
  text-transform: capitalize;
  align-self: stretch;
  white-space: nowrap;
  flex-grow: 1;
  flex-basis: auto;
  font: 400 16px Jost, sans-serif;
}

.div-5-1{
  margin-top: 5px;
}

.cardinfo hr {
  margin: 0.5rem 0;
}

@media (max-width: 991px) {
  .div-5 {
    white-space: initial;
  }
}


.participacion{
  border-radius: 5px;
  background-color: #37d359;
  color: #fff;
  text-align: center;
  line-height: 1;
  padding: 6px 0px;
  margin: 10px 0px;
}
.participacion span{
  font-size: 3rem;
  font-weight: 600;
}
.div-6 {
  align-self: stretch;
  display: flex;
  margin-top: 8px;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.div-9 {
  background-color: rgba(17, 44, 76, 0.1);
  align-self: stretch;
  display: flex;
  margin-top: 0px;
  width: 100%;
  height: 10px;
  flex-direction: column;
}

.div-9-fill{
  background-color: #fa9a28;
  height: 100%;
}
.div-10 {
  margin-top: 6px;
  text-align: center;
  margin-bottom: 4px;
}

.cardinfo a{
  margin: 0 auto;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;;AAGA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sBAAsB;;AAE1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;;;AAIA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,oBAAoB;;AAExB;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,cAAc;;;AAGlB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;;;AAIA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;;AAEf;;;AAGA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;;AAEf;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;;AAEf;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;;AAEf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;;;;;;;;;AAUA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;EACE,gCAAgC;;AAElC;;;;;;AAMA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;EACE,gCAAgC;;AAElC;;;;;AAKA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;EACE,gCAAgC;;AAElC;;;;;AAKA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;EACE,gCAAgC;;AAElC;;;;AAIA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;EACE,gCAAgC;;AAElC;;;;AAIA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE;IACE,WAAW;IACX,iBAAiB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA4BA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;AACF;;;;;;;AAOA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;;;;;;;AASA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,0BAA0B;EAC1B,iBAAiB,EAAE,kEAAkE;EACrF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB,EAAE,uDAAuD;EAC1E,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;AACA,gBAAgB;AAChB,kCAAkC;AAClC,gBAAgB;AAChB,cAAc;AACd,kBAAkB;AAClB,kBAAkB;AAClB,gBAAgB;AAChB,WAAW;AACX,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,yBAAyB;AACzB,2BAA2B;AAC3B,UAAU;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;;;;;;;;;;;;;;;;;;;AAwBA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb;;AAEF;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE;IACE,oBAAoB;EACtB;;AAEF;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Jost:wght@400;500;600;800&display=swap');\n\nbody{\n  font-family: 'Jost';\n  background-color: #f7f7fd;\n  color: #112c4c;\n}\n\n\n.btn-secondary {\n  color: #fff;\n  background-color: #112c4c;\n  border-color: #112c4c;\n}\n\n.borde-img {\n  border-radius: 10px;\n  border-style: solid;\n  border-color: #ffffff;\n  border-width: 1px;\n  overflow: hidden;\n}\n\n.descripcionap{\n  border-radius: 5px;\n  background-color: #ffffff;\n  padding: 20px;\n  margin-top: 20px;\n}\n\na {\n    color: #02aaec;\n    text-decoration: none;\n}\n\n.nav-link:focus, .nav-link:hover {\n  color: #0b6d9b;\n}\n\na:hover {\n  color: #0b6d9b;\n}\n\n.card-e a{\n  color: #112c4c !important;\n}\n\n.btn-primary {\n  color: #fff !important;\n  background-color: #02aaec;\n  border-color: #02aaec;\n}\n.btn-danger{\n  background-color: #d37c35;\n  border-color: #d37c35;\n}\n\n\n.login .btn{\n  width: 100%;\n  padding: 13px 20px;\n  font-size: 1.2rem;\n}\n.login .logo{\n  padding: 50px;\n  width: 220px;\n}\n.login .iniciodes{\n  display: inline-block;\n}\n.login .iniciodes hr{\n  background-color: #00b1e6;\n  margin-top: -5px;\n  height: 2px;\n  opacity: 1;\n}\n\n\n.login .form-control {\n\n    border-radius: 6px;\n    border: 1px solid #d5e0ee;\n    background-color: #f9fbfe;\n    align-self: start;\n    display: flex;\n    margin-top: 7px;\n    width: 100%;\n    height: 50px;\n    flex-direction: column;\n\n}\n\n.login label {\n  margin-top: 15px;\n}\n\n.login .olvidaste{\n  float: right;\n  margin-right: 10px;\n}\n\n\n\n.bg-dark {\n  color: #fff!important;\n  background-color: #112c4c!important;\n  padding: 19px 48px 19px 50px;\n}\n\n.nav-link {\n  color: #fff;\n  margin: 0 10px 0 10px;\n}\n\n.link-secondary {\n  color: #a5a5a5!important;\n}\n\n.img-nav{\n  vertical-align:top;\n  margin-right: 2px;\n}\n\n.logo-w{\n  width: 142px;\n  padding-left: 100px;\n}\n\n\n.enc{\n    font-size: 1.1rem;\n    margin: 0px 0 10px 0;\n\n}\n\n.card1{\n\n    border-radius: 8px;\n    border: 1px solid #ededfb;\n    background-color: #fff;\n    width: 100%;\n    margin: 0 auto;\n\n\n}\n\n.img1{\n  width: 200px;\n}\n\n.card-title{\n  color: #02aaec;\n  font-size: 1.3rem;\n}\n\n.circle{\n  height: 15px;\n  vertical-align: baseline;\n}\n\n.astats{\n  height: 45px;\n}\n\n.ainfo{\n  text-align: left;\n}\n\n\nh4{\n  font-weight: 600;\n}\n\n.table1 h4{\n  text-align: center;\n  margin-bottom: 15px;\n}\n\nth {\n  font-weight: 600;\n}\n\n\n\n.colmd3{\n  background-color: #ffffff;\n  border-radius: 5px;\n}\n\n.rendimiento{\n  padding: 15px 0px;\n  position: relative;\n  border: 1px solid #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n\n.rendimiento h4{\n  text-align: center;\n}\n\n.rendimiento select{\n  margin: 12px auto;\n  display: block !important;\n  width: 200px;\n  text-align: center;\n}\n\n\n.crendimiento{\n  width: 100%;\n}\n\n.rultimos{\n  width: 100%;\n  height: 350px;\n}\n\n\n.prendimiento{\n  width: 100%;\n  color: #ffffff;\n  background-color: #112c4c;\n  border-radius: 5px;\n  font-size: 5rem;\n  font-weight: 600;\n  text-align: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin: 20px 30px;\n  width: 80%;\n}\n\n.inversioninfo hr{\n  color: #dfdfdf;\n  margin: 0 !important;\n}\n\n.inversioninfo{\n  margin-top: 15px;\n}\n.inversioninfo h2{\n  font-weight: bold;\n  text-align: center;\n}\n\n.inversioninfo span{\n  text-align: center;\n  display: block;\n  color: #999999;\n  font-size: 1.1rem;\n}\n\n\n\n.perfil{\n  text-align: center;\n  padding: 15px 15px;\n}\n\n.perfil img{\n  margin: 5px;\n  margin-bottom: 15px;\n}\n\n.pinfo{\n  background-color: #f7f7fd;\n  border-radius: 5px;\n  border: 1px solid rgba(223, 223, 223, 0.521);\n}\n\n.separa{\n  border-left: 1px solid #dfdfdf;\n}\n\n.pinfo .row .col {\n  padding: 10px;\n}\n.pinfo .row .col span{\n  font-size: 0.7rem;\n}\n\n.pinfo .row .col h6{\n  margin-bottom: 2px;\n}\n\n\n.charts{\n  background-color: #fff;\n  padding: 20px 10px 120px 10px;\n  border-radius: 8px;\n  height: 500px;\n  \n}\n\n\n.charts-1{\n  background-color: #fff;\n  padding: 20px 10px 50px 10px;\n  border-radius: 8px;\n  height: 500px;\n  \n}\n.charts-rentals{\n  background-color: #fff;\n  padding: 20px 10px 50px 10px;\n  border-radius: 8px;\n  height: 400px;\n  \n}\n\n.charts-sales{\n  background-color: #fff;\n  padding: 20px 10px 50px 10px;\n  border-radius: 8px;\n  height: 407px;\n  \n}\n\n.tit-flujo{\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-left: 20px;\n}\n\n.usd-flujo{\n  font-size: 2rem;\n  font-weight: 800;\n  margin-left: 20px;\n}\n\n.porc-flujo{\n  font-size: 1.2rem;\n  color: #00ad45;\n  font-weight: 600;\n  margin-left: 10px;\n}\n\n\n.flujo{\n  width: 150px;\n  float: right;\n}\n\n.wflujo{\n  width: 100%;\n  height: 100%;\n}\n\n.table1 h5{\n  text-align: center;\n}\n.table{\n  color: #112c4c !important;\n}\n.table1{\n  background-color: #fff;\n  padding: 20px 30px 10px 30px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n}\n\n.table>:not(:first-child) {\n  border-top: 0px solid transparent !important;\n}\n\n.table>thead {\n  vertical-align: bottom;\n  background-color: #f2f2fd !important;\n  border-radius: 5px;\n}\n\n.cverde{\n  color: #00ff00;\n  vertical-align: bottom;\n}\n\n.min49 {\n  min-width: 49px;\n}\n\n\n\n\n\n\n\n\n\n.cwhite{\n  background-color: #ffffff;\n  border-radius: 5px;\n}\n.cdark{\n  background-color: #112c4c;\n  border-radius: 5px;\n  color: #ffffff;\n  padding: 38px 50px;\n}\n\n.cdark > span{\n  font-size: 1.2rem;\n  margin-left: 17px;\n}\n\n.cdark div{\n    width: 100%;\n    text-align: center;\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.cdark div span{\n  border-bottom: 2px solid #f25948;\n\n}\n\n\n\n\n\n.cdark2{\n  background-color: #112c4c;\n  border-radius: 5px;\n  color: #ffffff;\n  padding: 38px 50px;\n}\n\n.cdark2 > span{\n  font-size: 1.2rem;\n  margin-left: 17px;\n}\n\n.cdark2 div{\n    width: 100%;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.cdark2 div span{\n  border-bottom: 2px solid #f25948;\n\n}\n\n\n\n\n.cdark3{\n  background-color: #6b8bb1;\n  border-radius: 5px;\n  color: #ffffff;\n  padding: 38px 50px;\n}\n\n.cdark3 > span{\n  font-size: 1.2rem;\n  margin-left: 17px;\n}\n\n.cdark3 div{\n    width: 100%;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.cdark3 div span{\n  border-bottom: 2px solid #ffffff;\n\n}\n\n\n\n\n.corange{\n  background-color: #ff9f5e;\n  border-radius: 5px;\n  color: #ffffff;\n  padding: 38px 50px;\n}\n\n.corange > span{\n  font-size: 1.2rem;\n  margin-left: 17px;\n}\n\n.corange div{\n    width: 100%;\n    text-align: center;\n    font-size: 1.7rem;\n    font-weight: bold;\n}\n\n.corange div span{\n  border-bottom: 2px solid #ffffff;\n\n}\n\n\n\n.cwhiteinfo{\n  background-color: #ffffff;\n  border-radius: 5px;\n  padding: 38px 50px;\n}\n\n.cwhiteinfo > span{\n  font-size: 1.2rem;\n  margin-left: 17px;\n  color: #999999;\n}\n\n.cwhiteinfo div{\n    width: 100%;\n    text-align: center;\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.cwhiteinfo div span{\n  border-bottom: 2px solid #ff9955;\n\n}\n\n\n\n.arotop{\n  text-align: center;\n}\n.aro{\n  width: 150px;\n  display: inline-block;\n}\n\n.ocup{\n  width: 150px;\n  display: inline-block;\n  text-align: center;\n  color: #999999;\n  font-size: 1.3rem;\n  vertical-align:middle;\n}\n\n\n.periodo{\n  width: 150px;\n  display: inline-block;\n}\n.title-gr{\n  margin-right: 20px;\n  font-size: 1.25rem;\n  font-weight: 500;\n}\n\n\n@media (max-width: 1500px) {\n  .logo-w {\n    width: 40px;\n    padding-left: 0px;\n}\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media (max-width: 768px) { \n  .charts{\n    margin-top: 30px;\n  }\n  .nav-link {\n    padding: 1rem 1rem;\n    font-size: 1.5rem;\n  }\n  .nav-item{\n    border-top: 1px solid rgba(255, 255, 255, 0.219);\n  }\n  .navbar-collapse{\n    margin-top: 30px;\n  }\n  .img-nav{\n    vertical-align:middle;\n  }\n}\n\n\n\n\n\n\n.table1 div h4{\n  color:#ff9955;\n  text-align: center;\n}\n\n.table1 div h4 i{\n  color:#02AAEC;\n  margin: 0 30px;\n  cursor: pointer;\n}\n\ntbody tr th i{\n  color: #00D293;\n  margin-right: 10px;\n}\n\n.gris{\n  color: #c0c0c0;\n}\n\n\n\n\n\n\n\n\n.mkplace{\n  padding: 10px 5px 10px 0px ;\n  text-align: center;\n}\n\n.mkplace h5 a{\n  color:#112c4c;\n}\n\n.timeline {\n  position: relative;\n  margin: 20px 0;\n}\n\n.timeline::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 30px;\n  width: 2px;\n  border: 1px dashed #e0e0f6;\n  margin-left: -1px; /* Para corregir el espacio en blanco a la izquierda de la línea */\n  z-index: 0;\n}\n\n.timeline-item {\n  position: relative;\n  padding: 0px 20px;\n  margin-bottom: 40px;\n  margin-left: 50px; /* Ajusta la separación entre la línea y el contenido */\n  z-index: 1;\n}\n\n.timeline-item > .row{\n  margin-bottom: 10px;\n}\n\n.timeline-item .row .col{\n  margin-top: -20px;\n}\n\n.timeline-item .row .col a{\n  font-weight: 600;\n  color: #112c4c;\n}\n\n.timeline-item .row .col a:hover{\n  font-weight: 600;\n  color: #0c58b6;\n}\n\n.timeline-item::before {\ncontent: '\\f1d8';\nfont-family: 'Font Awesome 5 Free';\nfont-weight: 900;\ncolor: #ffffff;\nposition: absolute;\ntext-align: center;\npadding-top: 7px;\nleft: -39px;\nwidth: 40px;\nheight: 40px;\nborder-radius: 50%;\nbackground-color: #112c4c;\ntransform: translateY(-50%);\nz-index: 1;\n}\n\n.fechamp{\n  font-size: 0.7rem;\n  color: #666666;\n}\n\n.disponiblemp{\n  color: #00ad45;\n  background-color: #deffeb;\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 3px 6px;\n  width: 100%;\n  display: inline-block;\n  text-align: center;\n  border-radius: 5px;\n}\n\n.mkplace h5{\n  text-align: center;\n  font-weight: 600;\n  padding: 10px;\n}\n\n.contmp{\n  border:1px solid #e6e6e6;\n  border-radius: 5px;\n  padding: 10px 10px 5px 10px;\n}\n\n.contmp hr{\n  margin: 3px;\n}\n\n.contmp .row .col-8{\n  text-align: right;\n}\n\n.tituloitemmp{\n  color:#02aaec;\n  font-weight: 600;\n}\n.demp{\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n.tirvan{\n  font-size: 0.9rem;\n  color: #666666;\n}\n.parti{\n  font-weight: 600;\n  text-align: center;\n}\n\n.mkplace .btn-secondary{\n  font-weight: 600;\n  text-align: center;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.l-proyectos a{\n  color: #112c4c;\n}\n\n.divcard {\n  border-radius: 8px;\n  background-color: #fff;\n  color: #112c4c;\n  display: flex;\n  width: 374px;\n  flex-direction: column;\n  margin: 20px auto;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n}\n.cardinfo{\n  padding: 20px;\n  }\n\n.img {\n  /*aspect-ratio: 1.73;*/\n  object-fit: contain;\n  object-position: center;\n  width: 100%;\n  overflow: hidden;\n  align-self: stretch;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.div-2 {\n  align-self: stretch;\n  display: flex;\n  margin-top: 0px;\n  flex-direction: column;\n  width: 100%;\n  /*padding: 0 24px 0 25px;*/\n}\n@media (max-width: 991px) {\n  .div-2 {\n    /*padding: 0 20px;*/\n  }\n}\n.div-3 {\n  \n  text-transform: capitalize;\n  align-self: stretch;\n  white-space: nowrap;\n  font: 600 18px Jost, sans-serif;\n}\n@media (max-width: 991px) {\n  .div-3 {\n    white-space: initial;\n  }\n  \n}\n.div-4 {\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  margin-top: 8px;\n  justify-content: space-between;\n  gap: 6px;\n}\n.img-2 {\n  aspect-ratio: 1;\n  object-fit: contain;\n  object-position: center;\n  width: 16px;\n  overflow: hidden;\n  align-self: center;\n  max-width: 100%;\n  margin: auto 0;\n}\n\n.div-5 {\n  color: #444;\n  text-transform: capitalize;\n  align-self: stretch;\n  white-space: nowrap;\n  flex-grow: 1;\n  flex-basis: auto;\n  font: 400 16px Jost, sans-serif;\n}\n\n.div-5-1{\n  margin-top: 5px;\n}\n\n.cardinfo hr {\n  margin: 0.5rem 0;\n}\n\n@media (max-width: 991px) {\n  .div-5 {\n    white-space: initial;\n  }\n}\n\n\n.participacion{\n  border-radius: 5px;\n  background-color: #37d359;\n  color: #fff;\n  text-align: center;\n  line-height: 1;\n  padding: 6px 0px;\n  margin: 10px 0px;\n}\n.participacion span{\n  font-size: 3rem;\n  font-weight: 600;\n}\n.div-6 {\n  align-self: stretch;\n  display: flex;\n  margin-top: 8px;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.div-9 {\n  background-color: rgba(17, 44, 76, 0.1);\n  align-self: stretch;\n  display: flex;\n  margin-top: 0px;\n  width: 100%;\n  height: 10px;\n  flex-direction: column;\n}\n\n.div-9-fill{\n  background-color: #fa9a28;\n  height: 100%;\n}\n.div-10 {\n  margin-top: 6px;\n  text-align: center;\n  margin-bottom: 4px;\n}\n\n.cardinfo a{\n  margin: 0 auto;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
